import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

const AppointmentTable = ({ appointments }) => {
  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Appointment Date</TableCell>
            <TableCell>Appointment Slot</TableCell>
            <TableCell>Doctor</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Resolution</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {appointments.map((a) => (
            <TableRow key={a._id}>
              <TableCell>{a.slotDate}</TableCell>
              <TableCell>{a.slot}</TableCell>
              <TableCell>{a.doctorName}</TableCell>
              <TableCell>{a.reason}</TableCell>
              <TableCell>{a.resolution || "-"}</TableCell>
              <TableCell>{a.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default AppointmentTable;
